module.exports = __webpack_public_path__ + "sprites-226.5a28dfe95452d0d8037e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/sprites/sprites-226.svg
// module id = 93
// module chunks = 2